import React from 'react';
import { Handle, Position } from 'reactflow';
import { Box, Flex, Icon, Text } from 'pounceV2';
import { useFormikContext } from 'formik';
import { CorrelationRule } from 'Source/graphql/fragments/CorrelationRule.generated';
import { capitalizeWordsInString } from 'Helpers/utils';
import { useTheme } from '@mui/material';
import { ALERT_NODE_WIDTH_PX, getFlowChartColors } from './constantsV3';

const AlertNodeV3 = () => {
  const { values } = useFormikContext<CorrelationRule>();
  const theme = useTheme();
  const FLOW_CHART_COLORS = getFlowChartColors(theme.palette.tokens);
  const { severity } = values;
  const { backgroundColor, borderColor } = React.useMemo(
    () =>
      severity
        ? {
            backgroundColor: FLOW_CHART_COLORS.ALERT[`${severity}_BACKGROUND`],
            borderColor: FLOW_CHART_COLORS.ALERT[`${severity}_BORDER`],
          }
        : {
            backgroundColor: FLOW_CHART_COLORS.STEP.BACKGROUND,
            borderColor: FLOW_CHART_COLORS.STEP.BORDER,
          },
    [
      severity,
      FLOW_CHART_COLORS.ALERT,
      FLOW_CHART_COLORS.STEP.BACKGROUND,
      FLOW_CHART_COLORS.STEP.BORDER,
    ],
  );

  return (
    <Box
      backgroundColor={backgroundColor}
      border="2px solid"
      borderRadius="xlarge"
      borderColor={borderColor}
      width={`${ALERT_NODE_WIDTH_PX}px`}
      p={3}
      sx={{
        backdropFilter: 'blur(12px)',
      }}
    >
      <Handle
        type="target"
        position={Position.Top}
        isConnectable={false}
        style={{
          opacity: '0',
        }}
      />
      <Flex direction="row" gap={2} align="center">
        <Box
          backgroundColor={values.severity ? borderColor : FLOW_CHART_COLORS.ALERT.NO_SEVERITY_ICON}
          borderRadius="medium"
          p={2}
        >
          <Icon size="small" type="warning" m="auto" display="block" />
        </Box>
        <Flex direction="column" align="flex-start">
          <Text textAlign="center" color={FLOW_CHART_COLORS.SECONDARY_TEXT}>
            ALERT
          </Text>
          <Text textAlign="center">
            {values.severity ? capitalizeWordsInString(severity.toLowerCase()) : 'Severity'}
          </Text>
        </Flex>
      </Flex>
    </Box>
  );
};

export default AlertNodeV3;
